/*
 * COPYRIGHT Transtron Inc 2022
 *
 * 機能名：アイコン
 *
 * 作成者：2022/01/07 ノア）虞
 * 最終修正者：2022/01/07 ノア）虞
 *
 */
import Vue from 'vue'
import TtiSvgIcon from '@/components/TtiSvgIcon.vue'

Vue.component('tti-svg-icon', TtiSvgIcon)
const req = require.context('./svg', false, /\.svg$/)
req.keys().map(req)
